import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FBoxContainer } from '../../../../../components/base';
import LegacyGoalsPracticedList from './legacy-goals/GoalsPracticedListLegacy';
import GoalsPracticedList from './goals/GoalsPracticedList';
import ClientProgress from './ClientProgress';
import Synopsis from './Synopsis';
import { FORTA_BLUE } from '../../../../../utils/colors';

import type { ISessionGoalsAndTrials } from '../../../../../utils/types';

interface IGoalsAndProgressProps {
  isEditable: boolean;
  values: any;
  showErrors: boolean;
  updateFieldValue: (field: string, value: string | Record<string, string | boolean>) => void;
  setGoalsPracticedList: (list: ISessionGoalsAndTrials | null) => void;
  useNewUi: boolean;
}

function GoalsProgress({
  isEditable,
  values,
  showErrors,
  updateFieldValue,
  setGoalsPracticedList,
  useNewUi,
}: IGoalsAndProgressProps) {
  const goals_and_trials = values.goals_and_trials;
  const { t } = useTranslation('sessionNotes');

  const goalsPracticedContent = Array.isArray(goals_and_trials) ? (
    <LegacyGoalsPracticedList data={goals_and_trials} />
  ) : (
    <GoalsPracticedList
      isEditable={isEditable}
      evidenceBasedInterventionsUsed={values.evidence_based_interventions_used}
      onUpdate={(goalsPracticedList) => setGoalsPracticedList(goalsPracticedList)}
      showError={showErrors}
      useNewUi={useNewUi}
    />
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <ClientProgress
        isEditable={isEditable}
        clientProgress={values.client_progress}
        onChange={updateFieldValue}
        useNewUi={useNewUi}
      />
      {useNewUi ? (
        <Box sx={{ mb: 3 }}>{goalsPracticedContent}</Box>
      ) : (
        <FBoxContainer sx={{ mb: 3, borderRadius: '10px', boxShadow: 'none' }}>
          <Typography fontSize={21} color={FORTA_BLUE.primary} textAlign="left" mb={2.5}>
            {t('goalsPracticed.title')}
          </Typography>
          {goalsPracticedContent}
        </FBoxContainer>
      )}
      <Synopsis
        isEditable={isEditable}
        client_adheres_with_targets_or_goals={
          values?.synopsis?.client_adheres_with_targets_or_goals
        }
        no_behavior_issues_or_family_changes={
          values?.synopsis?.no_behavior_issues_or_family_changes
        }
        onChange={(key, value) => {
          updateFieldValue('synopsis', {
            [key]: value,
          });
        }}
        useNewUi={useNewUi}
      />
    </Box>
  );
}

export default GoalsProgress;
